import { create } from 'zustand'
import type { TokenClaims } from '../lib/authz'
import { parseTokenClaims } from '../lib/authz'

export type SessionMe = {
  userId: string
  subject?: string
  email?: string
  displayName: string
  status?: string
  regionCode?: string
}

/**
 * refreshToken 存独立 localStorage 键（不进 Zustand 状态）；
 * accessToken 只保留在内存（Zustand），页面刷新后走静默续期恢复会话。
 */
export const REFRESH_TOKEN_KEY = 'seven.refreshToken'

export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY)
  } catch {
    return null
  }
}

export function setRefreshToken(token: string): void {
  try {
    localStorage.setItem(REFRESH_TOKEN_KEY, token)
  } catch {
    /* 存储不可用时静默降级：仅内存会话 */
  }
}

export function clearRefreshToken(): void {
  try {
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  } catch {
    /* ignore */
  }
}

type AuthState = {
  token: string | null
  me: SessionMe | null
  setSession: (token: string, refreshToken: string, me: SessionMe | null) => void
  setToken: (token: string) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>()((set) => ({
  token: null,
  me: null,
  setSession: (token, refreshToken, me) => {
    setRefreshToken(refreshToken)
    set({ token, me })
  },
  setToken: (token) => set({ token }),
  clear: () => {
    clearRefreshToken()
    set({ token: null, me: null })
  },
}))

export function useTokenClaims(): TokenClaims | null {
  return parseTokenClaims(useAuthStore((s) => s.token))
}
